import len from './len.js';

export {
    len
}
